import TourProductFactory from '@/js/common/Domain/Factory/TourProduct';
import getTourFirstPaymentDefinitionService from '@/js/common/Domain/Service/getTourFirstPaymentDefinition';
import countryConditions from '@ve/components/countryConditions/common/store/countryConditions';
import OperatorsRepository from '@/js/common/Domain/Repository/Operators';
import apiToursToTourProducts from '@/js/common/Domain/Service/search/apiToursToTourProducts';

import populateRoomDescriptions from './populateRoomDescriptions';

export default function updateData(data) {
    const operatorsRepository = OperatorsRepository.repository;

    const {
        searchData,
        tourCriteria,
        tourProductsRepository,
    } = data;

    const {
        countries,
        tours,
        legs,
        routes,
        tariffs,
        rooms = [],
        operators = [],
        airlines,
        firstPaymentDefinitions = [],
    } = searchData;

    operatorsRepository.add(operators);

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.time('builTourProducts');
    }

    const toursWithRoomDescriptions = populateRoomDescriptions({
        tours,
        rooms,
    });

    const populatedTourProducts = apiToursToTourProducts({
        tours: toursWithRoomDescriptions,
        firstPaymentDefinitions,
        routes,
        tariffs,
        legs,
        airlines,
    });

    const country = tourCriteria ? tourCriteria.get('countries').at(0) : false;

    const currentTourProductsIndex = tourProductsRepository.pluck('id');

    const resorts = country ? country.get('resorts') : false;
    let newTourProductModels = [];

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log('TourProducts from request:', populatedTourProducts?.length || 0);
    }

    if (countries) {
        countryConditions.update(countries);
    }

    if (populatedTourProducts) {
        newTourProductModels = _.reduce(populatedTourProducts, (newTourProducts, tourProduct) => {
            if (!~_.indexOf(currentTourProductsIndex, tourProduct.tour.id)) {
                const firstPaymentDefinition = getTourFirstPaymentDefinitionService(tourProduct);
                const allFirstPaymentDefinitions = tourProduct?.firstPaymentDefinitions || [];

                newTourProducts.push(new TourProductFactory({
                    ...tourProduct,
                    firstPaymentDefinition,
                    allFirstPaymentDefinitions,
                }, resorts));
            }

            return newTourProducts;
        }, []);

        tourProductsRepository.add(newTourProductModels);
    }

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.timeEnd('builTourProducts');
        console.log('Added new tourProducts:', newTourProductModels.length);
    }

    return newTourProductModels;
}
